import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PortHomeComponent } from './port-home.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PortActiveVesselsModule } from "./port-active-vessels/port-active-vessels.module";
import { PortInactiveVesselsModule } from "./port-inactive-vessels/port-inactive-vessels.module";
import { PortHomeRoutingModule } from './port-home-routing.module';



@NgModule({
  declarations: [
    PortHomeComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    PortActiveVesselsModule,
    PortInactiveVesselsModule,
    PortHomeRoutingModule
],
  exports:[
    PortHomeComponent
  ]
})
export class PortHomeModule { }
